const isBrowser = (): boolean => typeof window !== 'undefined' && 'HTMLVideoElement' in window;

export const isSupported = (): boolean =>
  isBrowser() && typeof window.HTMLVideoElement?.prototype?.getVideoPlaybackQuality === 'function';

const isWebKitSupported = (): boolean =>
  isBrowser() && 'webkitDroppedFrameCount' in window.HTMLVideoElement.prototype;

const isMozillaSupported = (): boolean =>
  isBrowser() && 'mozPaintedFrames' in window.HTMLVideoElement.prototype;

export function getVideoPlaybackQuality(video: HTMLVideoElement): VideoPlaybackQuality {
  if (isSupported()) {
    return video.getVideoPlaybackQuality();
  }

  if (isWebKitSupported()) {
    const webKitVideo = video as any;
    return {
      corruptedVideoFrames: 0,
      creationTime: window.performance?.now?.() ?? Date.now(),
      droppedVideoFrames: webKitVideo.webkitDroppedFrameCount || 0,
      totalVideoFrames: webKitVideo.webkitDecodedFrameCount || 0,
    };
  }

  if (isMozillaSupported()) {
    const mozVideo = video as any;
    return {
      corruptedVideoFrames: 0,
      creationTime: window.performance?.now?.() ?? Date.now(),
      droppedVideoFrames: 0,
      totalVideoFrames: mozVideo.mozPaintedFrames || 0,
    };
  }

  return {
    corruptedVideoFrames: 0,
    creationTime: window.performance?.now?.() ?? Date.now(),
    droppedVideoFrames: 0,
    totalVideoFrames: 0,
  };
}
